//my items
import { useEffect, useContext, useState } from "react";
import { GlobalContext } from "@/store";
import { Button, Dimmer, Loader } from "semantic-ui-react";
import { useRouter } from "next/router";
import useWeb3 from "@/hooks/useWeb3";
import Layout from "@/components/Layout";
import Header from "@/components/Header";
import Global from "@/components/Constants";
import Images from "@/common/Images";
import ModalCreateCollection from "@/components/home/MarketplaceIce/minter/ModalCreateCollection.component";

import styles from "./Minter.module.scss";

const NO_IMAGE =
  "https://uning.es/wp-content/uploads/2016/08/ef3-placeholder-image.jpg";

const Minter = () => {
  // get DCL events data from the Context API store
  const [state] = useContext(GlobalContext);
  const { userCollectionsAddresses } = useWeb3();

  const [loading, setLoading] = useState(true);
  const [creatorModalOpen, setCreatorModalOpen] = useState(false);

  const router = useRouter();

  const fetchData = async () => {
    setLoading(false);
  };

  useEffect(() => {
    if (!state.userAddress) return;
    fetchData();
  }, [state.userAddress]);

  const handleClick = (address) => {
    router.push(`/marketplace/minter/${address}`);
  };

  return (
    <Layout>
      <Header
        title={Global.CONSTANTS.TITLE + " | Marketplace"}
        description={Global.CONSTANTS.DESCRIPTION}
        image={Images.SOCIAL_SHARE}
      />

      <div className={styles.main_container} style={{ marginTop: "50px" }}>
        <div className={styles.page_container}>
          <div className={styles.row}>
            <div className={styles.rowItem}>
              <h4>My collections minted</h4>
            </div>
            <div className={styles.rowItem}>
              <Button
                className={styles.button}
                onClick={() => setCreatorModalOpen(true)}
              >
                Create
              </Button>
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.rowItems}>
              <div>
                {loading ? (
                  <Dimmer active>
                    <Loader>Loading</Loader>
                  </Dimmer>
                ) : (
                  <div className={styles.row}>
                    {userCollectionsAddresses.map((token, index) => (
                      <div
                        className={styles.container}
                        key={index}
                        onClick={handleClick.bind(
                          null,
                          token.collectionAddress
                        )}
                      >
                        <div className={styles.imageContainer}>
                          <img
                            src={
                              token.collectionImage
                                ? token.collectionImage
                                : NO_IMAGE
                            }
                            className={styles.image}
                          />
                        </div>
                        <div className={styles.name}>
                          <span style={{ textOverflow: "ellipsis" }}>
                            {token.collectionName}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalCreateCollection
        open={creatorModalOpen}
        setOpen={setCreatorModalOpen}
      />
    </Layout>
  );
};

export default Minter;
